import React, { useEffect, useState } from "react";
import { homeImagesApi, getImageUrl } from "../api";
import ImageLoader from "./common/ImageLoader";
import "./AdminHomeImages.css";

const AdminHomeImages = () => {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const res = await homeImagesApi.getAll();
      setImages(res.data || []);
    } catch (err) {
      console.error("❌ Error fetching images:", err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedImage) return alert("Please select an image first!");

    setLoading(true);
    const formData = new FormData();
    formData.append("image", selectedImage);

    try {
      await homeImagesApi.upload(formData);
      alert("✅ Image uploaded successfully!");
      setSelectedImage(null);
      setPreviewUrl(null);
      e.target.reset();
      fetchImages();
    } catch (err) {
      console.error("❌ Upload failed:", err);
      alert("Upload failed. Try again!");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this hero image?")) return;

    try {
      await homeImagesApi.delete(id);
      fetchImages();
      alert("🗑️ Image deleted!");
    } catch (err) {
      console.error("❌ Delete failed:", err);
    }
  };

  return (
    <div className="admin-home-images-wrapper">
      <div className="admin-panel-header">
        <div className="panel-title-group">
          <i className="fas fa-images title-icon"></i>
          <div>
            <h2>Home Page Hero Images</h2>
            <p className="panel-subtitle">Manage hero banner carousel images displayed on the main landing page</p>
          </div>
        </div>
      </div>

      <div className="home-images-container-grid">
        {/* Upload Form Box */}
        <div className="upload-box-card">
          <h3 className="sub-heading-tag"><i className="fas fa-cloud-upload-alt"></i> Upload New Banner</h3>
          
          <form onSubmit={handleUpload} className="admin-glass-form">
            <div className="admin-form-group">
              <label>Select Banner Image (JPG, PNG, WEBP)</label>
              <input type="file" accept="image/*" onChange={handleFileChange} required />
            </div>

            {previewUrl && (
              <div className="image-preview-wrapper">
                <img src={previewUrl} alt="Preview" />
              </div>
            )}

            <button type="submit" className="admin-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-circle-notch fa-spin"></i> Uploading...
                </>
              ) : (
                <>
                  <i className="fas fa-upload"></i> Add to Hero Slider
                </>
              )}
            </button>
          </form>
        </div>

        {/* Existing Images Gallery */}
        <div className="images-list-card">
          <h3 className="sub-heading-tag">
            <i className="fas fa-photo-video"></i> Active Hero Banners ({images.length})
          </h3>

          {images.length === 0 ? (
            <p className="no-items-text">No hero images uploaded yet.</p>
          ) : (
            <div className="admin-img-grid">
              {images.map((img) => (
                <div key={img.id} className="admin-img-card">
                  <ImageLoader
                    src={getImageUrl(img.imagePath)}
                    alt="Hero Banner"
                  />
                  <div className="img-overlay-bar">
                    <span className="banner-id-badge">#{img.id}</span>
                    <button 
                      className="delete-img-btn" 
                      onClick={() => handleDelete(img.id)}
                      title="Delete this image"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminHomeImages;
